import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CommentInfoFragment,
  HistoryInfoFragment,
  OfferConfirmationQueryQueryCgResponse,
  OfferConfirmationQueryQueryVariables,
} from '@common/graphql';
import { BillingCardFragment } from '@institutions/graphql';

export type OfferConfirmationType =
  OfferConfirmationQueryQueryCgResponse['offer'];

export type OfferChangeRequestType =
  OfferConfirmationType['offerChangeRequests'][number];

export const OFFER_CONFIRMATION_QUERY: TypedDocumentNode<
  OfferConfirmationQueryQueryCgResponse,
  OfferConfirmationQueryQueryVariables
> = gql`
  query OfferConfirmationQuery($id: ID!) {
    offer(id: $id) {
      id
      state
      stateChangedAt
      rejectionReason
      rejectionDetails
      canAccept {
        value
      }
      canReject {
        value
      }
      startDate
      endDate
      billingRegularRate
      timeoffDescription
      shiftType
      shiftsPerWeek
      hoursPerShift
      overtimeThreshold
      comments {
        ...CommentInfoFragment
      }
      history {
        ...HistoryInfoFragment
      }
      offerChangeRequests {
        id
        note
        createdAt
        updatedAt
        canCreateResponse {
          value
        }
        worksMembership {
          id
          name
        }
        offerChangeResponse {
          id
          note
          updatedAt
          worksMembership {
            id
            name
          }
          detail {
            ... on OfferAcceptanceResponseDetail {
              id
              oldBillingRegularRate
              oldStartDate
              oldEndDate
              oldShiftType
              oldShiftsPerWeek
              oldHoursPerShift
              oldTimeoffDescription
            }
            ... on ExtensionOfferAcceptanceResponseDetail {
              id
              oldStartDate
              oldEndDate
              oldShiftType
              oldShiftsPerWeek
              oldHoursPerShift
              oldTimeoffDescription
            }
          }
        }
      }
      staffingRequestApplication {
        id
        employmentType
        organization {
          id
          name
          overtimeConfig {
            id
            maxRegularHours
          }
          organizationSetting {
            id
            timekeepingEnabled
          }
        }
        worksProfile {
          id
          fullName
        }
        canExtendOfferWeekAssignment {
          value
        }
        canIncreaseOfferRate {
          value
        }
        canSubmit {
          value
        }
        staffingRequest {
          id
          code
          externalId
          startDate
          endDate
          billingRegularRate
          billingCard {
            ...BillingCardFragment
          }
          length
          shiftType
          shiftsPerWeek
          hoursPerShift
          staffingRequestType
          canUpdate {
            value
          }
          role {
            id
            abbreviation
          }
          organizationUnit {
            id
            department {
              id
              name
              organizationBusiness {
                id
                name
                city
                stateCode
              }
            }
          }
        }
      }
    }
  }
  ${BillingCardFragment}
  ${CommentInfoFragment}
  ${HistoryInfoFragment}
`;
